import { render, staticRenderFns } from "./PartnershipList.vue?vue&type=template&id=769c47aa&"
import script from "./PartnershipList.vue?vue&type=script&lang=js&"
export * from "./PartnershipList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports